/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'renewal/h2': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M11.151 18.126H9.06v-5.37H3.656v5.37h-2.1V6.04h2.1v5.03H9.06V6.04h2.091v12.086zM22.444 18.126h-8.126V16.74l4.026-4.391c.58-.648.993-1.187 1.237-1.619.249-.437.373-.874.373-1.312 0-.575-.163-1.04-.49-1.394-.32-.354-.755-.531-1.303-.531-.653 0-1.16.199-1.519.597-.36.399-.54.944-.54 1.636h-2.017c0-.736.166-1.398.498-1.984a3.484 3.484 0 011.437-1.378c.625-.327 1.344-.49 2.158-.49 1.173 0 2.097.296 2.772.888.68.587 1.021 1.4 1.021 2.44 0 .604-.171 1.238-.515 1.902-.337.658-.893 1.408-1.668 2.249l-2.955 3.163h5.611v1.61z" _fill="currentColor"/>'
  }
})
